import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateBreadcrumb } from './store/breadcrumbSlice';
import { updateIntent } from './store/intentSlice';
const ContactIssueSelector = (props) => {
  const dispatch = useDispatch()
  const intentSelection = useSelector((state) => state.intent.value);

  const handleIntentClick = (event) => {
    dispatch(updateIntent(event.target.getAttribute('data-category')));
    (event.target.getAttribute('data-category')) ? dispatch(updateBreadcrumb("review")) : dispatch(updateBreadcrumb("describe"))

    // Analytics: Fire event18 and set eVar 128 when intent category is selected
    s.events = "event17";
    s.eVar128 = `supp: ${event.target.getAttribute('data-category')}`;
    s.tl();
  }

  const intentClass = (intent) => {
    const selectedClass = (intentSelection === intent) ? "active" : "";
    return ("contact-intent "+selectedClass);
  }

  const jsonToIntentArr = () => {
    const intentArr = []
    Object.entries(props.contentSelfHelp).forEach(([key, value]) => {
      const arr = []
      arr.push(key)
      arr.push(value["category_title"])
      intentArr.push(arr)
    });
    return(intentArr)
  }

  const intentTopic = (intent) => {
      return(<div className={intentClass(intent[0])} key={intent[0]} data-category={intent[0]}>{intent[1]}</div>)
  }

  return (
    <div id="contact-self-help">
      {intentSelection ? "" : <div id="contact-describe-subheader" className="contact-subheader contact-pt-50">{props.contentStrings["describe-subheader"]}</div>}
      
      <div id="contact-intent-group" onClick={handleIntentClick}>
        {jsonToIntentArr().map(intentTopic)}
        <div className="contact-text" data-category="other">{props.contentStrings["describe-not-listed"]}</div>
      </div>
    </div>
  )
}

export default ContactIssueSelector